<template lang="pug">
  b-field.select-label(:label="label")
    b-dropdown(v-model="innerData" @change="changeValue")
      b-field.has-addons(slot="trigger")
        .control
          template(v-if="innerData")
            b-button(icon-right="menu-down")
              | {{innerData.fullNameShort}}
          b-button.has-text-grey(v-else icon-right="menu-down") Ответственный

        .control(v-if="withReset && innerData")
          b-button.o-9(icon-left="close" @click.stop="changeValue(null)" :type="innerData.labelColor")

      template(v-if="isFilterMode")
        b-dropdown-item(@click="changeValue(0)")
          b-icon.mr-5(icon="empty")
          span Не назначен

        b-dropdown-item(separator=true)

      b-dropdown-item(v-for="executor in executors.items" :key="executor.id" :value="executor")
        b-icon.mr-5(icon="account-tie")
        span {{executor.fullNameShort}}
</template>

<script>
import User from '@/models/User';

export default {
  name: 'select-executor',

  props: {
    value: [String, Number],
    executor: Object,
    label: String,
    withReset: Boolean,
    type: String,
    isFilterMode: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    executors: User.collection(),
    innerData: null,
  }),

  watch: {
    value(executorId) {
      this.updateInnerData(null, executorId);
    },
  },

  methods: {
    async loadState() {
      await this.executors.$fetch({
        sort: 'last_name',
        filter: { role_id: 1 },
      });
      this.$emit('onLoadState', this.executors);
    },

    changeValue(executor) {
      this.$emit('input', executor === 0 ? 0 : executor ? executor.id : null);
      this.$emit('update:executor', executor || null);
    },

    updateInnerData(executor, executorId) {
      if (executor) {
        this.innerData = executor;
      } else if (this.executors) {
        this.innerData = this.executors.find(executorId);
      }
    },
  },

  async created() {
    this.updateInnerData(this.executor);
    await this.loadState();
    if (!this.executor) {
      this.updateInnerData(null, this.value);
    }
  },
};
</script>
